import { MutationTree } from 'vuex';
import { CommentView, CommentsState } from './models';

export enum Mutations {
  GET_COMMENTS_REQUEST = 'GET_COMMENTS_REQUEST',
  GET_COMMENTS_SUCCESS = 'GET_COMMENTS_SUCCESS',
  GET_COMMENTS_FAILURE = 'GET_COMMENTS_FAILURE',
}

export const mutations: MutationTree<CommentsState> = {
  [Mutations.GET_COMMENTS_REQUEST](state) {
    state.comments = [];
  },
  [Mutations.GET_COMMENTS_SUCCESS](state, payload: CommentView[]) {
    state.comments = payload;
  },
  [Mutations.GET_COMMENTS_FAILURE](state) {
    state.comments = [];
  },
};
